// this method is used to get the key for the virtualization flat list
export const getFlatListKey = ({ itemId, groupId }: { itemId: string; groupId?: string }): string =>
	`${itemId}${groupId ? `::${groupId}` : ''}`;
